import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SiC, SiCsharp, SiJavascript, SiTypescript } from 'react-icons/si';
import { DiJava } from 'react-icons/di';

const Programming = () => {
  return (
    <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiJavascript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCsharp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiC />
      </Col>
    </Row>
  );
};

export default Programming;
